import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  PropsWithChildren,
} from 'react';
import clone from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';
import { GREEN } from './constants';

interface ITheme {
  primaryColor: string;
}

const DEFAULT_THEME: ITheme = { primaryColor: GREEN };

const ThemeContext = createContext<ITheme>(clone(DEFAULT_THEME));

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeContextProvider');
  }
  return context;
};

interface IThemeContextProviderProps {
  value?: ITheme;
}

export const ThemeContextProvider = ({
  value = DEFAULT_THEME,
  children,
}: PropsWithChildren<IThemeContextProviderProps>) => {
  const [theme, setTheme] = useState<ITheme>(value);

  useEffect(() => {
    if (!isEqual(theme, value)) {
      setTheme(value);
    }
  }, [value]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};
